import * as Yup from "yup";

export const validation = (t) =>
    Yup.object({
        lastname: Yup.string()
            .min(2, `${t("registration.minLength")}2`)
            .max(32, `${t("registration.maxLength")}32`)
            .required(t("registration.required")),
        firstname: Yup.string()
            .min(2, `${t("registration.minLength")}2`)
            .max(32, `${t("registration.maxLength")}32`)
            .required(t("registration.required")),
        middlename: Yup.string()
            .min(2, `${t("registration.minLength")}2`)
            .max(32, `${t("registration.maxLength")}32`),
        mobile_phone: Yup.string()
            .min(5, `${t("registration.minLength")}5`)
            .max(15, `${t("registration.maxLength")}15`)
            .required(t("registration.required")),
        email: Yup.string()
            .email(t("registration.invalidEmail"))
            .max(32, `${t("registration.maxLength")}32`)
            .required(t("registration.required")),
    });
